(() => {
  const fmt = (cents, format) => {
    const v = (cents / 100).toFixed(2);
    const [i, d] = v.split('.');
    const withCommas = i.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const f = format || '${{amount}}';
    return f.replace(/\{\{\s*amount\s*\}\}/, withCommas + '.' + d)
            .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas)
            .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withCommas.replace(/,/g, '.') + ',' + d);
  };

  /* ---------- Gallery ---------- */
  document.querySelectorAll('[data-o-gallery]').forEach((g) => {
    const track = g.querySelector('[data-o-track]');
    const thumbs = g.querySelectorAll('[data-o-thumb]');
    const dots = g.querySelectorAll('.o-gallery__dots span');
    const setActive = (i) => {
      thumbs.forEach((t, k) => t.setAttribute('aria-current', k === i ? 'true' : 'false'));
      dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
    };
    thumbs.forEach((t) => t.addEventListener('click', () => {
      const i = +t.dataset.oThumb;
      track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
      setActive(i);
    }));
    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => setActive(Math.round(track.scrollLeft / track.clientWidth)));
    });
  });

  /* ---------- Offer box ---------- */
  class OOffer extends HTMLElement {
    connectedCallback() {
      this.data = JSON.parse(this.querySelector('[data-o-product]').textContent);
      this.tiers = [...this.querySelectorAll('[data-o-tier]')];
      this.subCheck = this.querySelector('[data-o-sub-check]');
      this.subBox = this.querySelector('[data-o-subbox]');
      this.gifts = [...this.querySelectorAll('[data-o-gift]')];
      this.btn = this.querySelector('[data-o-atc]');
      this.err = this.querySelector('[data-o-err]');
      this.giftsSubOnly = this.dataset.giftsSubOnly === 'true';
      this.mode = this.subCheck && this.subCheck.checked ? 'sub' : 'once';
      const active = this.tiers.find((t) => t.classList.contains('is-active')) || this.tiers[0];
      this.tier = active || null;
      this.variantId = active ? +active.dataset.variant : this.data.variants[0].id;

      this.tiers.forEach((t) => t.addEventListener('click', (e) => { e.preventDefault(); this.selectTier(t); }));
      if (this.subCheck) this.subCheck.addEventListener('change', () => this.selectMode(this.subCheck.checked ? 'sub' : 'once'));
      this.btn.addEventListener('click', () => this.add());

      const section = this.closest('.o-pdp');
      this.sticky = section && section.querySelector('[data-o-sticky]');
      if (this.sticky) {
        this.sticky.querySelector('[data-o-sticky-btn]').addEventListener('click', () => {
          this.btn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
        const io = new IntersectionObserver(([e]) => {
          const show = !e.isIntersecting && e.boundingClientRect.top < 0;
          this.sticky.classList.toggle('is-visible', show);
          this.sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
        io.observe(this.btn);
      }
      if (this.tier) this.selectTier(this.tier); else this.render();
    }
    variant(id) { return this.data.variants.find((v) => v.id === +id); }
    priceFor(v) { return this.mode === 'sub' && v.sub != null ? v.sub : v.price; }
    selectTier(t) {
      this.tiers.forEach((x) => { x.classList.toggle('is-active', x === t); x.querySelector('input').checked = x === t; });
      this.tier = t; this.variantId = +t.dataset.variant; this.render();
    }
    selectMode(m) {
      this.mode = m;
      if (this.subBox) this.subBox.classList.toggle('is-active', m === 'sub');
      this.render();
    }
    giftsActive() { return !(this.giftsSubOnly && this.mode !== 'sub'); }
    render() {
      const money = this.data.money;
      this.tiers.forEach((t) => {
        const v = this.variant(t.dataset.variant); if (!v) return;
        const now = this.priceFor(v);
        const was = Math.max(v.compare || 0, this.mode === 'sub' ? v.price : 0);
        t.querySelector('[data-o-now]').textContent = fmt(now, money);
        t.querySelector('[data-o-was]').textContent = was > now ? fmt(was, money) : '';
        const units = +t.dataset.units || 1;
        t.querySelector('[data-o-each]').textContent = units > 1 ? fmt(Math.round(now / units), money) + ' each' : '';
        const tg = t.querySelector('[data-o-tier-gifts]');
        if (tg) tg.style.opacity = this.giftsActive() ? '1' : '.4';
      });
      const units = this.tier ? +this.tier.dataset.units || 1 : 1;
      this.gifts.forEach((g) => g.classList.toggle('is-unlocked', (this.giftsActive() || g.dataset.any === 'true') && units >= (+g.dataset.unlock || 1)));
      const v = this.variant(this.variantId);
      if (v) {
        const p = fmt(this.priceFor(v), money);
        this.querySelector('[data-o-atc-price]').textContent = '· ' + p;
        this.btn.disabled = !v.available;
        this.querySelector('[data-o-atc-text]').textContent = v.available ? (this.btn.dataset.label || this.querySelector('[data-o-atc-text]').textContent) : 'Sold out';
        if (!this.btn.dataset.label && v.available) this.btn.dataset.label = this.querySelector('[data-o-atc-text]').textContent;
        if (this.sticky) {
          const label = this.tier ? this.tier.querySelector('.o-tier__title').textContent : '';
          this.sticky.querySelector('[data-o-sticky-price]').textContent = (label ? label + ' · ' : '') + p;
        }
      }
    }
    async add() {
      const v = this.variant(this.variantId); if (!v) return;
      this.err.hidden = true; this.btn.disabled = true; this.btn.classList.add('loading');
      const items = [{ id: v.id, quantity: 1 }];
      if (this.mode === 'sub' && this.data.subPlan && v.sub != null) items[0].selling_plan = this.data.subPlan;
      if (this.tier && this.giftsActive()) {
        try {
          const ids = JSON.parse(this.tier.querySelector('[data-o-gift-ids]').textContent || '[]');
          ids.forEach((id) => items.push({ id, quantity: 1, properties: { _gift: 'Free gift' } }));
        } catch (e) {}
      }
      const drawer = document.querySelector('cart-drawer');
      const body = { items };
      if (drawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
      try {
        const res = await fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
        });
        const json = await res.json();
        if (!res.ok || json.status) throw new Error(json.description || json.message || 'Could not add to cart');
        if (drawer && json.sections) {
          drawer.classList.contains('is-empty') && drawer.classList.remove('is-empty');
          drawer.renderContents({ id: v.id, sections: json.sections });
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'o-offer' });
      } catch (e) {
        this.err.textContent = e.message; this.err.hidden = false;
      } finally {
        this.btn.disabled = false; this.btn.classList.remove('loading');
      }
    }
  }
  if (!customElements.get('o-offer')) customElements.define('o-offer', OOffer);

  /* ---------- Remove orphaned free gifts ---------- */
  const cleanGifts = async () => {
    try {
      const cart = await fetch('/cart.js').then((r) => r.json());
      const paid = cart.items.filter((i) => !(i.properties && i.properties._gift));
      const gifts = cart.items.filter((i) => i.properties && i.properties._gift);
      if (gifts.length && !paid.length) {
        const updates = {}; gifts.forEach((g) => (updates[g.key] = 0));
        await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }) });
        window.location.reload();
      }
    } catch (e) {}
  };
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (ev) => { if (!ev || ev.source !== 'o-offer') setTimeout(cleanGifts, 400); });
  }
})();

/* cart add-ons */
document.addEventListener('click', async (e) => {
  const b = e.target.closest('[data-o-addon]'); if (!b) return;
  e.preventDefault(); b.disabled = true; b.textContent = 'Adding…';
  try {
    const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +b.dataset.oAddon, quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }) });
    const j = await res.json(); if (!res.ok) throw new Error(j.description || 'Error');
    const d = document.querySelector('cart-drawer'); if (d && j.sections) d.renderContents({ id: +b.dataset.oAddon, sections: j.sections }); else location.reload();
  } catch (err) { b.disabled = false; b.textContent = '+ Add'; }
});
